// TODO : Update this
export const WalletConnectProjectId = '1994e8a2b0239cf64f303f30dcff6edf';
export const WalletConnectMetadata = {
    name: "GroveWars.com",
    description: "GroveWars.com",
    url: 'GroveWars.com',
    icons: ["https://tsub47683-explorer.thetatoken.org/images/icons/icon-grove.png"],
}

export const SubchainId = '47683';
export const SubchainGovernanceTokenAddress = '0xC1cFF4648D490480F3B7E1449aaE5f7a34A75DFA';
export const SubchainGovernanceTokenName = 'GROVE';
export const SubchainGovernanceTokenSymbol = 'GROVE';
export const SubchainStakingRewardPerYear = 37500000;
export const SubchainMainWebsite = 'https://www.grovewars.com';
export const SubchainMainWebsiteName = 'GroveWars.com';
export const STAKING_DISABLED = false;

export const NarBarBackButtonPrefersLogo = true;

export const CLAIMING_DISABLED = false;

export const Hosts = {
    API: process.env.REACT_APP_API_HOST
}

export const RequestState = {
    REQUEST: 'REQUEST',
    SUCCESS: 'SUCCESS',
    FAIL: 'FAIL',
    NOT_AUTHORIZED: 'NOT_AUTHORIZED',
}

export const AddressZero = "0x0000000000000000000000000000000000000000";
export const CurrentNetwork = process.env.REACT_APP_CURRENT_NETWORK;

export const NetworkInfoByChainId = {
    ['privatenet']: {
        ethRpc: 'http://localhost:18888/rpc',
        chainId: 'privatenet',
        chainIdNum: 366,
    },
    ['testnet']: {
        ethRpc: 'https://eth-rpc-api-testnet.thetatoken.org/rpc',
        chainId: 'testnet',
        chainIdNum: 365,
    },
    ['mainnet']: {
        ethRpc: 'https://eth-rpc-api.thetatoken.org',
        chainId: 'mainnet',
        chainIdNum: 361,
    }
}

export const CurrentNetworkInfo = NetworkInfoByChainId[CurrentNetwork];
export const WalletConnectionTypes = {
    MetaMask: 'MetaMask',
    ThetaWallet: 'ThetaWallet',
}

export const StorageKeys = {
    CurrentAccount: 'WALLET_CURRENT_ACCOUNT'
}

export const ModalTypes = {
    ConnectWallet: 'ConnectWallet',
    Alert: 'Alert',
    Loader: 'Loader',
    Stake: 'Stake',
    Unstake: 'Unstake'
}

export const ContractAddresses = {
    GovernanceToken: SubchainGovernanceTokenAddress,
    ChainRegistrarOnMainchain: '0xb164c26fd7970746639151a8C118cce282F272A7',
    TFuelTokenBank: '0xf83239088B8766a27cD1f46772a2E1f88e916322',
    TNT20TokenBank: '0xB3d93735de018Ad48122bf7394734A7d18007e1b',
    TNT721TokenBank: '0xFe2d1bE6bD9d342cfa59e75290F9b0B42cdBCDAF',
    TNT1155TokenBank: '0xA31168d669112937B0826b1Bf15f0eb12e6B1542',
    VCM: '0xF0d53cbE585F8Fa24A5108a1C741CE31AD18b40e',
    VSM: '0xf0716e6221618137fB05D72450e0FC8d9c2919d4',
    wTHETA: '0xaf537fb7e4c77c97403de94ce141b7edb9f7fcf0',

    ClaimingContractByNFTNameToBurn: {
        PineOGCommemorativeNFT: '0x220ed4c26a680df76682f60c9f6968af5c5dff68',
        GroveWarsCommemorativeNFT: '0x775369b031ded3aa3fb8c313f36adfe1e0783cc4',
    },
    PineOGCommemorativeNFT: '0x1f6b731158879f580fafbc2e81c8ee49e1882f72',
    GroveWarsCommemorativeNFT: '0x2d46743a5e165f93e1bf7330dff11c22541d04c3',
};

export const ClaimingContractByNFTToBurn = {
    [ContractAddresses.PineOGCommemorativeNFT]: ContractAddresses.ClaimingContractByNFTNameToBurn.PineOGCommemorativeNFT,
    [ContractAddresses.GroveWarsCommemorativeNFT]: ContractAddresses.ClaimingContractByNFTNameToBurn.GroveWarsCommemorativeNFT,
}

export const CollectibleNamesByAddress = {
    [ContractAddresses.PineOGCommemorativeNFT]: 'Pine "OG" Commemorative',
    [ContractAddresses.GroveWarsCommemorativeNFT]: 'GroveWars Commemorative'

}

export const ChainRegistrarOnMainchainContract = require("./contracts/ChainRegistrarOnMainchain.json");
export const ValidatorStakeManagerContract = require("./contracts/ValidatorStakeManager.json");
export const GovernanceTokenContract = require("./contracts/GovernanceToken.json")

export const TFuelTokenBankContract = require("./contracts/TFuelTokenBank.json")
export const TNT20TokenBankContract = require("./contracts/TNT20TokenBank.json")
export const TNT721TokenBankContract = require("./contracts/TNT721TokenBank.json")
export const TNT1155TokenBankContract = require("./contracts/TNT1155TokenBank.json")

export const ClaimingContract = require("./contracts/BurnNFTAndClaim.json")
export const NFTContract = require("./contracts/NFT.json")